<template>
    <billing-panel class="billing-support-card">
        <billing-icon-tile icon="mdi-lifebuoy" tone="blue" />
        <h3>Need help?</h3>
        <p>Contact our support team for billing and account assistance.</p>
        <v-btn variant="outlined" size="small" href="/support/">
            Contact Support
            <v-icon end size="15">mdi-open-in-new</v-icon>
        </v-btn>
    </billing-panel>
</template>

<script>
import BillingIconTile from './BillingIconTile.vue';
import BillingPanel from './BillingPanel.vue';

export default {
    name: 'BillingSupportCard',
    components: {
        BillingIconTile,
        BillingPanel,
    },
};
</script>

<style scoped>
.billing-support-card {
    padding: 18px;
}

.billing-support-card h3 {
    color: var(--billing-text);
    font-size: 16px;
    font-weight: 800;
    margin: 14px 0 6px;
}

.billing-support-card p {
    color: var(--billing-muted);
    font-size: 13px;
    line-height: 1.45;
    margin: 0 0 16px;
}
</style>
